// Pixel values inspired by https://tailwindcss.com/docs/screens
export default {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536
};
